import CryptoJS from "crypto-js";
import { io } from "socket.io-client";
import { ICE_SERVERS, SIGNALING_URL } from "./config";

export interface WireMessage { user:string; room:string; message:string; data:string; id:string }
export const socket = io(SIGNALING_URL, { autoConnect: false, transports: ["websocket", "polling"], reconnection: true, reconnectionAttempts: Infinity });

// Transfer protocol version advertised by this build (see PeerMode in use-webrtc-transfer.ts).
export const PROTOCOL=3;
export function protocolOf(message:string){try{return Number((JSON.parse(message) as {v?:unknown})?.v)||0}catch{return 0}}

export const roomKey = (room:string) => CryptoJS.MD5(room).toString().slice(0,16);
export const encrypt = (value:WireMessage,key:string) => CryptoJS.AES.encrypt(JSON.stringify(value),key).toString();
export function decrypt(value:string,key:string): WireMessage | null {
  try { const plain=CryptoJS.AES.decrypt(value,key).toString(CryptoJS.enc.Utf8); return plain ? JSON.parse(plain) : null; } catch { return null; }
}
export function sendWire(payload:WireMessage,key:string,metadata="") { socket.emit("message", {room:payload.room,data:encrypt(payload,key),type:payload.data,metadata}); }

// Adds the signaling server's TURN relay to the public STUN servers. Without it (old backend,
// network error) only direct routes are possible, which still works on most home networks.
// Credentials last three hours; caching them for one lets the pairing screen fetch them ahead of time.
const ICE_CACHE_MS=60*60*1000;
let iceCache:{at:number;servers:Promise<RTCIceServer[]>}|null=null;
export function loadIceServers(): Promise<RTCIceServer[]> {
  if(!iceCache||Date.now()-iceCache.at>ICE_CACHE_MS){
    const servers=fetchIceServers();iceCache={at:Date.now(),servers};
    void servers.then(list=>{if(list===ICE_SERVERS&&iceCache?.servers===servers)iceCache=null}); // Retry a failed fetch next time.
  }
  return iceCache.servers;
}
async function fetchIceServers(): Promise<RTCIceServer[]> {
  try {
    const response=await fetch(`${SIGNALING_URL}/api/turn`,{cache:"no-store",signal:AbortSignal.timeout?.(4000)});
    const body=await response.json() as {iceServers?:RTCIceServer[]};
    if(Array.isArray(body.iceServers)&&body.iceServers.length)return [...ICE_SERVERS,...body.iceServers];
  } catch { /* Fall back to STUN only. */ }
  return ICE_SERVERS;
}
